import React from 'react';
import { defaultCountries, parseCountry, PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

const countries = defaultCountries.filter((country) => {
    const { iso2 } = parseCountry(country);
    return ['in'].includes(iso2);
});

const MyPhoneInput = ({ field, error, isSubmitting, ...props }) => {
    return (
        <div className={`d-flex p-1 border border-top-0 border-start-0 border-end-0 
            ${isSubmitting ? 'bg-light' : 'bg-white'} 
            ${error ? 'border-1 border-danger' : "border-0"}`}>
            <PhoneInput
                {...field}
                {...props}
                defaultCountry="in"
                countries={countries}
                hideDropdown
                disableDialCodeAndPrefix
                showDisabledDialCodeAndPrefix
                disabled={isSubmitting}
                className=""
                inputClassName="border-0 bg-transparent fs-6 px-1 text-end"
                dialCodePreviewStyleProps={{
                    className: "border-0 p-0"
                }}
                countrySelectorStyleProps={{
                    buttonClassName: 'btn-secondary rounded-start-3 border-0 ps-2 pe-1',
                    flagClassName: 'country-flag',
                }}
            />
        </div>
    );
};

export default MyPhoneInput;
